
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25.042","height":"31.996"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Grupo 1020"}},[_c('g',{attrs:{"data-name":"Grupo 98"}},[_c('path',{attrs:{"data-name":"Rectángulo 74","fill":"#fff","stroke":"#0f587f","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.2","d":"M.6.6h23.842v30.796H.6z"}}),_c('path',{attrs:{"data-name":"Rectángulo 77","fill":"#0f587f","stroke":"#0f587f","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.2","d":"M.6.6h23.842v12.914H.6z"}}),_c('path',{attrs:{"data-name":"Trazado 111","d":"M8.985 7.956h2.36v2.36a.2.2 0 00.2.2h2.235a.2.2 0 00.2-.2v-2.36h2.36a.2.2 0 00.2-.2V5.518a.2.2 0 00-.2-.2h-2.36V2.956a.2.2 0 00-.2-.2h-2.233a.2.2 0 00-.2.2v2.36h-2.36a.2.2 0 00-.2.2v2.238a.2.2 0 00.2.2","fill":"#fff"}}),_c('g',{attrs:{"data-name":"Grupo 94","fill":"none","stroke":"#0f587f","stroke-linecap":"round","stroke-width":"1.2"}},[_c('path',{attrs:{"data-name":"Línea 42","d":"M4.047 17.404h3.447"}}),_c('path',{attrs:{"data-name":"Línea 44","d":"M4.047 20.851h3.447"}}),_c('path',{attrs:{"data-name":"Línea 46","d":"M4.047 24.298h3.447"}}),_c('path',{attrs:{"data-name":"Línea 48","d":"M4.047 27.745h3.447"}}),_c('path',{attrs:{"data-name":"Línea 43","d":"M10.941 17.404h10.341"}}),_c('path',{attrs:{"data-name":"Línea 45","d":"M10.941 20.851h10.341"}}),_c('path',{attrs:{"data-name":"Línea 47","d":"M10.941 24.298h10.341"}}),_c('path',{attrs:{"data-name":"Línea 49","d":"M10.941 27.745h10.341"}})])])])])
          )
        }
      }
    